export const getPowerBIReportProvidersState = (state) => state.powerBIReportProviders.powerBIProviders
export const getPowerBIProviderModalState = (state) => state.powerBIReportProviders.powerBIProviderModal
export const getPowerBIProviderConnectionCheckState = (state) =>
  state.powerBIReportProviders.powerBIProviderConnectionCheck
export const getPowerBIReportProviderState = (state) => state.powerBIReportProviders.powerBIProvider
export const getPowerBIProviderConfigurationState = (state) => state.powerBIReportProviders.powerBIProviderConfiguration
